export default "/images/bc4feb9f3c7675bb199e55c0bf2667d4.png";